module.exports = __webpack_public_path__ + "img/serum.f3ec9cca.png";